import { useState, useEffect } from 'react';

/**
 * Custom hook to generate the base URL for the showcase.
 * Handles removing query strings and replacing the path for viewer showcase.
 */
export const useBaseUrl = () => {
  const [baseUrl, setBaseUrl] = useState<string>();

  useEffect(() => {
    try {
      const url = new URL(window.location.href);

      // Remove the query string to ensure the base URL is always the gallery view URL
      url.search = '';

      setBaseUrl(url.href);
    } catch (error) {
      console.error('Failed to get base URL', error);
    }
  }, []);

  return baseUrl;
};
